import React from 'react';
import { Text } from './Text';
import classNames from 'classnames';

const orderedListVariants = ['decimal', 'decimalCircle', 'hangul', 'hangulCircle', 'alpha', 'alphaCircle'] as const;

type OrderedListVariant = (typeof orderedListVariants)[number];

interface TextListProps {
  variant?: OrderedListVariant;
  children: React.ReactNode;
  className?: string;
}

export const TextList: React.FC<TextListProps> = ({ variant, children, className }) => {
  const Tag = orderedListVariants.includes(variant as OrderedListVariant) ? 'ol' : 'ul';

  const processedChildren = React.Children.toArray(children).flatMap((child) => {
    if (React.isValidElement(child) && child.type === React.Fragment) {
      return React.Children.toArray((child.props as { children: React.ReactNode }).children);
    }
    return child;
  });

  return (
    <Tag className={classNames('dsx-TextList', variant && `dsx-TextList--${variant}`, className)}>
      {processedChildren.map((child, index) => {
        if (!React.isValidElement(child) || child.type !== Text) {
          throw new Error('TextList 바로 하위에는 Text 컴포넌트만 사용할 수 있습니다.');
        }
        return React.cloneElement(child, {
          //@ts-expect-error - The ref type is `any` due to limitations in typing the `ref` for different HTML elements.
          as: 'li',
          key: index,
        });
      })}
    </Tag>
  );
};
